import { Link, useNavigate } from "react-router-dom";
import { Calendar, MapPin, Users, Receipt, ChevronRight } from "lucide-react";

export default function EventCard({ event }) {
  const nav = useNavigate();
  const totalSlots = event.total_slots || 0;
  const confirmedSlots = event.confirmed_count || 0;
  const progressPct = totalSlots > 0 ? Math.round((confirmedSlots / totalSlots) * 100) : 0;

  const statusColor = event.status === "completed"
    ? "bg-emerald-100 text-emerald-700 border-emerald-200"
    : event.status === "closed"
    ? "bg-amber-100 text-amber-700 border-amber-200"
    : "bg-blue-100 text-blue-700 border-blue-200";

  return (
    <div
      className="card-flat hover:border-brand transition group cursor-pointer"
      onClick={() => nav(`/events/${event.id}`)}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-display text-xl tracking-tight text-foreground group-hover:text-brand transition truncate">
              {event.name}
            </h3>
            <span className={`text-xs px-2 py-0.5 rounded-full border font-medium ${statusColor}`}>
              {event.status}
            </span>
          </div>

          <div className="mt-2 flex flex-wrap gap-3 text-xs text-muted-foreground">
            {event.date && (
              <span className="flex items-center gap-1">
                <Calendar className="w-3.5 h-3.5" />
                {new Date(event.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
              </span>
            )}
            {event.venue && (
              <span className="flex items-center gap-1">
                <MapPin className="w-3.5 h-3.5" />
                {event.venue}
              </span>
            )}
            <span className="flex items-center gap-1">
              <Users className="w-3.5 h-3.5" />
              {confirmedSlots}/{totalSlots} staff
            </span>
            <span>{event.job_count || 0} role{event.job_count !== 1 ? "s" : ""}</span>
            {event.budget && (
              <span>Budget: ₹{event.budget.toLocaleString("en-IN")}</span>
            )}
          </div>

          {/* Progress bar */}
          {totalSlots > 0 && (
            <div className="mt-3">
              <div className="h-1.5 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-brand rounded-full transition-all"
                  style={{ width: `${progressPct}%` }}
                />
              </div>
              <p className="text-xs text-muted-foreground mt-1">{progressPct}% staff confirmed</p>
            </div>
          )}
        </div>
      </div>

      {/* Actions */}
      <div className="mt-4 flex gap-2 flex-wrap" onClick={e => e.stopPropagation()}>
        <Link to={`/manage-event/${event.id}`} className="btn-primary text-xs !py-2 !px-4 flex items-center gap-1">
          Manage <ChevronRight className="w-3.5 h-3.5" />
        </Link>
        <Link to={`/manage-event/${event.id}/expenses`} className="btn-outline text-xs !py-2 !px-4 flex items-center gap-1">
          <Receipt className="w-3.5 h-3.5" /> Expenses
        </Link>
        {event.is_public && (
          <Link to={`/events/${event.id}`} className="btn-outline text-xs !py-2 !px-4">
            Public page
          </Link>
        )}
      </div>
    </div>
  );
}
